import React from "react"
import config from 'react-global-configuration';
import * as moment from 'moment';

import Input from "./Input"
import styles from "../../styles/modal.css"



export default class ScheduleModal extends React.Component {

  constructor(){
    super()
    this.updateHandler = this.updateHandler.bind(this)
    this.createBtnHandler = this.createBtnHandler.bind(this)
    this.state = {
      target_date:null,
      comment:null
    }
  }

  componentDidMount(){

  }

  componentWillUnmount(){

  }

  updateHandler(name,value){
    switch(name){
      case "target_date" :
        this.setState({target_date:value})
      break;
      case "comment" :
        this.setState({comment:value})
      break;
    }
  }

  createBtnHandler(){
    this.props.createBtnHandler(this.props.event_id,this.state.target_date,this.state.comment)
    this.props.closeBtnHandler()
  }
  render(){



    return(
      <div className={"alert-box " + this.props.addclass} >
        <div className="alert-box-wrap gr" onClick={this.props.closeBtnHandler}></div>
        <div className="alert-box-wrap full-box">
          <div className="modal-header">
            <div className="closebtn" onClick={this.props.closeBtnHandler}><i className="fas fa-times"></i></div>
            <h2>参加予定登録</h2>
          </div>
          <div className="modalbox">
            <Input type="date" changeValueHandler={this.updateHandler} label="参加予定日" name="target_date" value={this.state.target_date} placeholder="年/月/日" />
            <Input type="textarea" changeValueHandler={this.updateHandler} label="コメント" name="comment" value={this.state.comment} placeholder="" />

            <div className="btn-box">
            <button className="create-btn " onClick = {this.createBtnHandler}>登録</button>
        </div>

          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/ScheduleModal.js